// Genre/Subgenre fields for the upload-create payload (Genre catalog v1).
//
// Genre and Subgenre are OPTIONAL on upload. The selection made in the
// Confirm Upload modal applies to the ENTIRE batch: every file's
// upload-create payload for that session carries the same fields. When
// nothing is selected the fields are omitted entirely (never sent as
// empty strings or null).

export interface UploadGenreSelection {
  genreId: string | "";
  subgenreId: string | "";
}

export function uploadGenreFields(
  selection: UploadGenreSelection | null | undefined,
): { genreId?: string; subgenreId?: string } {
  const genreId = selection?.genreId?.trim() || "";
  if (!genreId) return {};
  const subgenreId = selection?.subgenreId?.trim() || "";
  // Subgenre is only valid together with its Genre.
  return subgenreId ? { genreId, subgenreId } : { genreId };
}
